import styles from './occasion_card.module.scss';
import {OccasionType} from '../../../gql/pwa/graphql.ts';
import {Link, useSearchParams} from 'react-router-dom';
import {SimpleSlider} from '../../../components/slider.tsx';
import {formatEuro} from '../../../support/format_currency.ts';
import {formatKm} from '../../../support/format_distance.ts';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {VehicleBrandModel} from '../../../components/vehicle/vehicle_brand_model.tsx';
import {Alignment} from '../../../enums/alignment.ts';

interface OwnProps {
    occasion?: OccasionType | null;
}
export function OccasionCard({occasion}: OwnProps) {
    const [searchParams] = useSearchParams();
    return (
        <div className={styles.occasion}>
            <Link to={`/occasion/${occasion?.id}?${searchParams.toString()}`}>
                <div className={styles.occasion_slider}>
                    {occasion?.pictures && occasion.pictures?.length > 0 && (
                        <SimpleSlider>
                            {occasion.pictures.slice(0, 3).map((pic) => (
                                <div key={pic}>
                                    <img
                                        src={pic!}
                                        alt={occasion?.model ?? ''}
                                        onError={(e) => (e.currentTarget.style.display = 'none')}
                                    />
                                </div>
                            ))}
                        </SimpleSlider>
                    )}
                </div>

                {/*BRAND MODEL*/}
                <FlexRow alignment={Alignment.Center}>
                    <VehicleBrandModel brand={occasion?.brand ?? ''} model={occasion?.model ?? ''} />
                </FlexRow>

                {/*PRICE*/}
                <FlexRow alignment={Alignment.Center}>
                    <span className={styles.occasion_price}>
                        {occasion?.price != null && occasion?.price !== 0 ? (
                            <span className={styles.full_price}>{formatEuro(occasion.price)}</span>
                        ) : null}
                        {occasion?.price != null &&
                            occasion?.financing?.lease_price != null &&
                            occasion?.financing?.lease_price > 0 && <span>/</span>}
                        {occasion?.price != null &&
                        occasion?.financing?.lease_price != null &&
                        occasion?.financing?.lease_price > 0 ? (
                            <span className={styles.lease_price}>
                                {formatEuro(occasion.financing.lease_price)} p.m.
                            </span>
                        ) : null}
                    </span>
                </FlexRow>

                <div className={styles.occasion_icons}>
                    {occasion?.transmission != null && (
                        <span className={styles.icon_item}>
                            <i className="fa-light fa-gear"></i>
                            <span>{occasion.transmission}</span>
                        </span>
                    )}
                    {occasion?.fuel != null && (
                        <span className={styles.icon_item}>
                            <i className="fa-light fa-gas-pump"></i>
                            <span>{occasion.fuel}</span>
                        </span>
                    )}
                    {occasion?.mileage != null && (
                        <span className={styles.icon_item}>
                            <i className="fa-light fa-gauge"></i>
                            <span>{formatKm(occasion.mileage)}</span>
                        </span>
                    )}
                    {occasion?.build_year != null && (
                        <span className={styles.icon_item}>
                            <i className="fa-light fa-calendar"></i>
                            <span>
                                {occasion.build_month && <>{occasion.build_month} - </>}
                                {occasion.build_year}
                            </span>
                        </span>
                    )}
                </div>
            </Link>
        </div>
    );
}
